import "./App.css";
import { OktaIDP, AuthenticationState } from "./components/OktaIDP";

import { authProvider } from "./context/authProvider";
import { Header } from "./components/Header";
//import { HomePage } from "./pages/HomePage";
import { LoadingPage } from "./pages/LoadingPage";
//import { LoginPage } from "./pages/LoginPage";
//import { HubPage } from "./pages/HubPage";
import { AppWraper } from "./AppWraper";
//import { HomePage } from "./pages/HomePage";
import { UnAuthenticatedRouter } from "./router/UnAuthenticatedRouter";
import { RoleProvider } from "./context/RoleContext";
import { BrandPreviewProvider } from "./context/BrandPreviewContext";

// TODO VALIDAR authenticationState
function App() {
  return (
    <div className="App">
      <OktaIDP provider={authProvider}>
        {({ authenticationState, accountInfo }) => {
          let userEmail = null;

          if (
            authenticationState === AuthenticationState.Authenticated &&
            accountInfo &&
            accountInfo.account
          ) {
            userEmail =
              accountInfo.account.userName || accountInfo.idTokenClaims?.preferred_username;
            console.log("App.js - User authenticated email:", userEmail);
          }

          console.log("authenticationState", authenticationState);
          switch (authenticationState) {
            case AuthenticationState.Authenticated:
              return (
                <RoleProvider authenticatedUserEmail={userEmail}>
                  <BrandPreviewProvider>
                    <Header />
                    <AppWraper />
                  </BrandPreviewProvider>
                </RoleProvider>
              );
            case AuthenticationState.Unauthenticated:
              return <UnAuthenticatedRouter />;
            case AuthenticationState.InProgress:
              return <LoadingPage />;
            default:
              return null;
          }
        }}
      </OktaIDP>
    </div>
  );
}

export default App;
